<template>
  <!-- Error Modal -->
  <div
    id="errorModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="errorModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            id="errorModalLabel"
            class="modal-title"
          >
            {{ $t('label.modal.ERROR_MODAL_LABEL') }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          <div class="alert alert-danger">
            <p id="errorModalMsg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },

  methods: {
    showError (msg) {
      this.showErrorContent(this.$i18n.t('error.' + msg))
    },

    showErrorContent (content) {
      let errorModal = new Modal(document.getElementById('errorModal'))
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = content
    }
  }
}
</script>

<style scoped lang="scss">

</style>
